import React from "react"

const SelectionCell = ({
  selectionHandler,
  selectedRows,
  row: {
    original: { id }
  }
}) => {
  const handleSelection = (event) => {
    event.stopPropagation()
    const { checked } = event.target
    if (selectionHandler !== undefined) selectionHandler(id, checked)
  }

  return <input type="checkbox" checked={selectedRows.includes(id)} onChange={handleSelection} />
}

export default SelectionCell
